import React, { Component } from 'react';
import { createEdges } from './method';
import { renderShape } from "./NodeRender";
import { renderRunEdge } from "./edgeRender";
import chartPlugin from "./chartPlugin";
import './index.less';
import G6 from '@antv/g6';
import { getSafeRandom } from '@platform/api';
import { microAppUtil } from '@platform/api';
const { getDocument } = microAppUtil;

function uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (getSafeRandom() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export default class DagreChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                nodes: [],
                edges: [],
            },
            selectedId: this.props.selectedId || '', // 选中的节点id，页面初加载时选中节点为基本节点,即基于基本节点构建的上下游关系
            key: 1,
        };
        this.cuuid = uuidv4();
        this.size = false;
        this.showMax = false;
        this.lastSelectEdges = [];
        renderShape.call(this);
        renderRunEdge.call(this);

    }

    componentDidMount() {
        // 最大化不支持拖拽改变大小  BillErrorTrack的showMax=undefined
        this.props.showMax === false && this.props.onRef(this);
        let { list } = this.props;
        let nodes = list;
        let edges = [];
        nodes.forEach(item => edges.push(...createEdges(item)));
        this.setState(
            { data: { nodes, edges } },
            () => {
                this.initFlowChart();
                this.renderFlowChart(this.state.data);
            },
        );
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        let { list, extract } = nextProps;
        let nodes = list;
        let edges = [];
        // 以list里的billno作为唯一标识来判断是否需要更新
        let flag = false;
        if(list.length !== this.props.list.length){
            flag = true;
        }
        if(flag === false){
            for (let index = 0; index < list.length; index++) {
                if(this.props.list[index]?.billno !== list[index]?.billno){
                    flag = true;
                    break;
                }            
            }
        }
        if (this.props.extract !== extract || flag) {
            nodes.forEach(item => edges.push(...createEdges(item)));
            this.setState(
                { data: { nodes, edges }, key: this.state.key + 1 },
                () => {
                    this.initFlowChart();
                    this.renderFlowChart(this.state.data);
                },
            );
        }

    }

    // 初始化渲染并绑定节点事件
    initFlowChart() {
        let { showMax, size } = this.props;
        let { nodes } = this.state.data;
        let dom = null;
        // let _document = myContainer || document;
        let container = getDocument();
        if (showMax) {
            dom = container.querySelector('.bill-track-max')[0];
        } else {
            dom = container.querySelector(`.bill-track .bill-track-modal-body`);
        }
        if (dom) {
            let height = size ? dom.clientHeight / 2 : dom.clientHeight;
            // let container = _document.querySelector(".billtrack-dagre");
            this.graph = new G6.Graph({
                container: this.cuuid,
                height: height - 20,
                width: dom.clientWidth - 20,
                fitViewPadding: 10,
                fitView: nodes.length > 4,
                fitCenter: true,
                layout: {
                    preventOverlap: true,
                    type: 'dagre',
                    rankdir: 'LR', // 可选，默认为图的中心
                    align: 'DL', // 可选
                    nodesep: 50, // 可选
                    ranksep: 50, // 可选
                },
                defaultEdge: chartPlugin.defaultEdge,
                plugins: [chartPlugin.toolTip],
                modes: { default: ['drag-canvas', 'zoom-canvas', 'click-select', 'drag-node'] },
                defaultNode: { shape: 'card-node' },
            });
            this.itemClickEvent();
        }
    }
    componentWillUnmount() {
        this.lastSelectEdges = [];
    }

    // 节点的点击事件
    itemClickEvent = () => {
        this.graph.on('node:click', ev => {
            let nodeData = ev.item._cfg;
            if (nodeData && nodeData.type === 'node') {
                const node = ev.item;
                if (this.lastSelectNode) {
                    this.graph.setItemState(this.lastSelectNode, 'selected', false);
                }

                const edges = node.getEdges();
                const nowIds = edges.map(edge => edge._cfg.id);
                const lastIds = this.lastSelectEdges.length && this.lastSelectEdges.map(edge => edge._cfg.id) || [];
                if (this.lastSelectEdges.length) {
                    this.lastSelectEdges.forEach(edge => {
                        if (!nowIds.includes(edge._cfg.id)) {
                            this.graph.setItemState(edge, 'running', false);
                        }
                    });
                }
                edges.forEach(edge => {
                    if (!lastIds.includes(edge._cfg.id)) {
                        this.graph.setItemState(edge, 'running', true);
                    }
                });
                this.graph.setItemState(node, 'selected', true);
                this.lastSelectNode = node;
                this.lastSelectEdges = edges;
                let selectedId = nodeData.id;
                let selectedType = nodeData.model.type;
                if (selectedId !== this.state.selectedId) {
                    this.setState({ selectedId }, () => {
                        this.props.getSelectId && this.props.getSelectId(selectedId, selectedType);
                    });
                    // let data = this.changeColor(this.state.data);
                    // this.setState({ data }, () => this.renderDagre(data));
                }
            }
        });
        this.graph.on('node:dblclick', ev => {
            let nodeData = ev.item._cfg;
            if (nodeData && nodeData.type === 'node') {
                let selectedId = nodeData.id;
                let type = this.state.data.nodes.find(elem => {
                    return elem.id == selectedId;
                }).type;
                let transtype = this.state.data.nodes.find(elem => {
                    return elem.id == selectedId;
                }).transtype;
                this.props.onSelect && this.props.onSelect(selectedId, type, transtype);
            }
        });
        this.graph.on('node:mouseenter', ev => {
            const node = ev.item;
            this.graph.setItemState(node, 'hover', true);
        });

        this.graph.on('node:mouseleave', ev => {
            const node = ev.item;
            this.graph.setItemState(node, 'hover', false);
        });

        this.graph.on('edge:click', ev => {
            const edge = ev.item;
            if (this.lastSelectEdges.length) {
                this.lastSelectEdges.forEach(edge => this.graph.setItemState(edge, 'running', false));
            }
            this.graph.setItemState(edge, 'running', true);
            this.lastSelectEdges = [edge];
        });
    };

    renderFlowChart = data => {
        // const { centerId } = this.props
        data && this.graph.data(data);
        this.graph.render();
        // centerId && this.graph.focusItem(centerId)//初始化中心节点位置
    }

    render() {
        let { size } = this.props;
        return (
            <div
                className={`${this.props.className ? this.props.className : ''} dagre-area `}
                style={{ height: `${size ? '50%' : '100%'}` }}
                key={this.state.key}
            >
                <div id={this.cuuid} className="billtrack-dagre" />
            </div>
        );
    }
}